import { Injectable } from '@angular/core';
import { CreditInformationService } from '@app/core/services/credit-information.service';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, mergeMap, Observable, of, switchMap } from 'rxjs';
import { CountryType, isSweden } from '../../entity/locale';
import { CoreActions } from '../actions';
import { AppState } from '../appState';
import { FirmSelectors } from '../firm/firm.selectors';
import { CreditInformationType } from '../types/credit-information.types';
import { KvkInformationType } from '../types/kvk-information.types';
import { CreditInformationActions } from './credit-information.actions';

@Injectable()
export class CreditInformationEffects {
  loadCreditInformation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreditInformationActions.load),
      concatLatestFrom(() => this.store.select(FirmSelectors.selectCountryCode)),
      switchMap(([{ corporateIdentity }, countryCode]) =>
        this.getCompanyInformation(corporateIdentity, countryCode).pipe(
          mergeMap((creditInformation) => [CreditInformationActions.loadSucceeded({ creditInformation })]),
          catchError(() => of(CoreActions.noAction())), // handled by catchErrorAndShowMessage
        ),
      ),
    ),
  );

  private getCompanyInformation(
    corporateIdentity: string,
    firmCountryCode: CountryType,
  ): Observable<CreditInformationType | KvkInformationType> {
    if (isSweden(firmCountryCode)) {
      return this.creditInformationService.getSwedishCreditInformation(corporateIdentity);
    }
    return this.creditInformationService.getDutchCompanyInformation(corporateIdentity);
  }

  // eslint-disable-next-line no-useless-constructor
  constructor(
    private actions$: Actions,
    private creditInformationService: CreditInformationService,
    private store: Store<AppState>,
  ) {}
}
